import * as React from 'react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

//MUI Icons
import AddIcon from '@mui/icons-material/Add';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

//Custom Components
import DialogActionButton from '@/ui/Dialog/DialogActionButton';

//Types
import { IDialogActionButtonDetail } from '@/@types/ui/Dialog';

const DialogActionButtonAdd: FunctionComponent<IDialogActionButtonDetail> = (props) => {
  const { t } = useTranslation();

  const { continueAdd, next } = props;

  return (
    <DialogActionButton startIcon={next ? <NavigateNextIcon/> : <AddIcon />} {...props} ariaLabel="add" ariaControls="add">
      {t(continueAdd ? 'buttons.add_and_continue' : (next ? 'buttons.next' : 'buttons.add'))}
    </DialogActionButton>
  );
};

export default DialogActionButtonAdd;
